export default __webpack_public_path__ + "static/media/teams_active.7783b75c.svg";